export default "__VITE_ASSET__CazKOkG2__"